<script lang="ts">
	import {
		DropdownMenu,
		IconButton,
		Modal,
		SelectCard,
		CardGrid,
		MenuItemList,
	} from '@Shelly/shelly-design-system';
	import { locale } from 'svelte-i18n';
	import { LANG_LABELS, SUPPORTED_LANGS, setLocale, type SupportedLang } from '../lib/i18n';

	// Mirrors SystemScreenBreakpoints.TABLET_MAX from the design system enums
	// without taking a deep import dependency on a non-exported subpath.
	const TABLET_MAX = 1123;

	let showDropdown = $state(false);
	let showModal = $state(false);
	let windowClientWidth = $state(0);

	const isMobileOrTablet = $derived(windowClientWidth > 0 && windowClientWidth <= TABLET_MAX);

	const currentLang = $derived<SupportedLang>(
		(($locale ?? 'en').slice(0, 2) as SupportedLang),
	);
	const currentLangIso = $derived(currentLang.toUpperCase());

	const dropdownItems = SUPPORTED_LANGS.map((lang) => ({
		title: LANG_LABELS[lang],
		subtitle: lang.toUpperCase(),
		language: lang,
	}));

	function handleLanguageSelect(item: (typeof dropdownItems)[number]) {
		setLocale(item.language);
		if (isMobileOrTablet) {
			showModal = false;
		} else {
			showDropdown = false;
		}
	}

	function handleTriggerClick() {
		if (isMobileOrTablet) {
			showModal = true;
		} else {
			showDropdown = !showDropdown;
		}
	}

	function closeModal() {
		showModal = false;
	}
</script>

<svelte:window bind:innerWidth={windowClientWidth} />

{#if isMobileOrTablet}
	<IconButton variant="label" on:click={handleTriggerClick}>
		{currentLangIso}
	</IconButton>

	<Modal bind:showModal on:close={closeModal} hideTitle>
		<svelte:fragment slot="content">
			<CardGrid md={250} noPaddingBottom gridGap="s" class="mt-s mb-s">
				{#each dropdownItems as menuItem (menuItem.language)}
					<SelectCard
						hideAction
						type="horizontal"
						class="width-full"
						title={menuItem.title}
						selected={currentLang === menuItem.language}
						on:click={() => handleLanguageSelect(menuItem)}
					/>
				{/each}
			</CardGrid>
		</svelte:fragment>
	</Modal>
{:else}
	<DropdownMenu bind:show={showDropdown}>
		<IconButton slot="trigger" variant="label" on:click={handleTriggerClick}>
			{currentLangIso}
		</IconButton>
		{#each dropdownItems as menuItem (menuItem.language)}
			<MenuItemList
				title={menuItem.title}
				isSelectable
				selected={currentLang === menuItem.language}
				on:click={() => handleLanguageSelect(menuItem)}
			/>
		{/each}
	</DropdownMenu>
{/if}
